/**
 * Human-readable labels for internal operator codes (INTERNAL_OPERATOR_REALTIME_V1).
 * Unknown codes fall back to formatted machine id.
 */

export const INTERVENTION_MODE_HINTS = {
  auto: 'Rithmo proposes nudges; low-friction automation.',
  manual: 'You approve what goes out; nothing ships without your OK.',
  hybrid: 'Rithmo drafts; you confirm sensitive moves.',
}

/** @param {string | undefined} code */
export function formatOperatorCode(code) {
  if (!code || typeof code !== 'string') return 'Notice'
  return code.replace(/_/g, ' ')
}

const WARNING_LABELS = {
  internal_item_unlinked: 'Internal goal is not linked to a public topic',
  internal_item_link_missing_from_runtime: 'Linked public topic is missing from the live agenda',
  internal_item_at_risk: 'Internal goal appears at risk',
  agenda_drift_internal_item: 'Agenda drift is putting this goal at risk',
  topic_moved_without_decision: 'Topic advanced without a captured decision',
  internal_agenda_unlinked: 'Internal goal not linked to a public topic',
  internal_agenda_stale: 'Internal goals may be out of sync with the live agenda',
  coverage_gap: 'Possible gap between discussion and agenda',
  timebox_pressure: 'Running short on time for this segment',
}

const STATUS_REASON_LABELS = {
  no_public_topic_link: 'No linked public topic',
  linked_topic_not_in_live_agenda: 'Linked topic missing from live agenda',
  linked_topic_not_reached: 'Linked topic not reached yet',
  linked_topic_active_without_decision: 'Topic is active without a captured output',
  linked_topic_has_decision: 'Output captured for topic',
  linked_topic_has_action_or_follow_up_only: 'Output captured (action item or follow-up)',
  agenda_drift_elevated: 'Agenda drift elevated',
  linked_topic_advanced_without_decision: 'Meeting moved on without a captured output',
}

/** @param {string | undefined} code */
export function warningCodeLabel(code) {
  if (!code) return 'Notice'
  return WARNING_LABELS[code] ?? formatOperatorCode(code)
}

/** @param {string | undefined} code */
export function statusReasonCodeLabel(code) {
  if (!code) return 'Reason unavailable'
  return STATUS_REASON_LABELS[code] ?? formatOperatorCode(code)
}
